const SIZE_GUIDES = [
  {
    title: { SIZE_GUIDES_BUST_TITLE: 'Bust' },
    description: {
      SIZE_GUIDES_BUST_DESCRIPTION:
        'Measure around the fullest part of your bust and across the shoulder blade, back to the front',
    },
  },
  {
    title: { SIZE_GUIDES_WAIST_TITLE: 'Waist' },
    description: {
      SIZE_GUIDES_WAIST_DESCRIPTION:
        'Measure around your natural waistline, generally an inch above your belly button and below your rib cage',
    },
  },
  {
    title: { SIZE_GUIDES_HIPS_TITLE: 'Hips' },
    description: {
      SIZE_GUIDES_HIPS_DESCRIPTION:
        'Measure around the widest part at the top of your hip. Start at one hip and wrap the tape measure around your hips and back around to where you started',
    },
  },
]

export default SIZE_GUIDES
